<template>
  <div class="swiper_bg" id="Honor">
    <!--    <div class="swiper-button-prev swiper-button-prev1">-->
    <!--        </div>-->
    <div class="middle_banner">
      <img class="bannerleft" src="../../../static/img/green-left.png" @click="slideToPrev"/>
      <div class="swiper-container mySwiper mySwiper1" id="mySwiper1">
        <div class="swiper-wrapper">
          <!-- Slides -->
          <!-- <div class="swiper-slide" v-for="(item, index) in List" :key="index"> -->
          <div class="swiper-slide" v-for="(item, index) in zzry" :key="index">
            <!-- <img src="../../static/img/3A证书.png" /> -->
            <img class="book1_img" :src="item.image"/>
          </div>
        </div>
        <img class="swiper_bottom_gg" src="../../../static/img/bottom_gg.png"/>
        <p class="swiper_title">
          {{ getLocalizedText() }}
        </p>
        <div class="swiper-pagination"></div>
      </div>
      <img class="bannerright" src="../../../static/img/green-right.png" @click="slideToNext"/>
    </div>
  </div>
</template>
<script>
import * as API from "@/api/index";
import Swiper, {Pagination, EffectCoverflow} from "swiper";

Swiper.use([Pagination, EffectCoverflow]);
import "swiper/swiper-bundle.css";

export default {
  props: {
    language: {
      type: String,
      default: "",
    },
    honorList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    //监听轮播数据变化后再创建实例
    zzry() {
      this.$nextTick(() => {
        let that = this;
        this.swiper = new Swiper(".mySwiper1", {
          effect: 'coverflow',
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: 0,
          loop: true,
          // autoplay: {
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
          pagination: {
            el: ".swiper-pagination",
          },
          coverflowEffect: {
            rotate: 30,
            stretch: 0,
            depth: 60,
            modifier: 2,
            slideShadows: false,
          },
          on: {
            slideChange: function () {
              // 当轮播切换时更新标题
              that.changetext(this.activeIndex);
            }
          },
          breakpoints: {
            "@0.00": {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            "@0.75": {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            "@1.00": {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
        });
      });
    },
  },
  data() {
    return {
      bannertext: "",
      bannertextEn: "",
      bannertextEs: "",
      zzry: [],
      swiper: Object,
    };
  },
  mounted() {
    this.getInfo();
  },
  beforeDestroy() {
  },
  created() {
  },
  methods: {
    getInfo() {
      var data = {limit: 1000};
      API.getHonorBannerList({page: 1, limit: 100})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list) {
              this.zzry = res.page.list;
              // 初始化显示第一个项目的标题
              if (this.zzry.length > 0) {
                this.changetext(0);
              }
            }
          })
          .catch(() => {
          });

    },
    changetext(i) {
      this.bannertext = this.zzry[i].titleCn;
      this.bannertextEn = this.zzry[i].titleEn;
      this.bannertextEs = this.zzry[i].titleEs;
    },
    getLocalizedText() {
      if (this.$i18n.locale === 'zh') {
        return this.bannertext;
      } else if (this.$i18n.locale === 'es') {
        return this.bannertextEs || this.bannertextEn;
      }
      return this.bannertextEn;
    },
    slideToNext() {
      // var swiper = document.getElementById('mySwiper1');
      this.swiper.slideNext();
      // this.$mySwiper1.slideTo(1);
    },
    slideToPrev() {
      this.swiper.slidePrev();
    },
  },
};
</script>
<style lang="stylus" scoped>
.page_btn_div {
  display: flex;

  img {
    width: 5rem;
    height: 5rem;
    margin: 0 1rem;
    cursor: pointer;
  }

  .prev {
    cursor: pointer;
    width: 5rem;
    height: 5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../../../static/img/swiper_left.png');

    &:hover {
      background-image: url('../../../static/img/swiper_left2.png');
    }
  }

  .next {
    cursor: pointer;
    margin-left: 1rem;
    width: 5rem;
    height: 5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../../../static/img/swiper_right.png');

    &:hover {
      background-image: url('../../../static/img/swiper_right2.png');
    }
  }
}

.book1_img {
  height: 38rem;
  object-fit: cover;
  //border-radius: 2rem;
  // transform: scale(0.7);
}

.book1_img:hover {
  // transform: scale(1.0);
}

.swiper_bg {
  // margin: 5rem 0;
  // padding: 3rem 0;
}

.swiper_title {
  margin: 5rem 0 0;
  font-family: demibold;
  font-size: 2.6rem;
  text-align: center;
}
.swiper_bottom_gg{
  width: 100%;
  height: 4rem;
  object-fit: contain;
}

.bannerright {
  width: 4rem;
  height: 4rem;
  cursor: pointer;
  z-index: 99;
  flex-shrink: 0;
  object-fit: contain;
}

.bannerleft {
  width: 4rem;
  height: 4rem;
  cursor: pointer;
  z-index: 99;
  flex-shrink: 0;
  object-fit: contain;
}

.bannerleft:hover, .bannerright:hover {
  opacity: 0.7;
}

.swiper-button-prev {
  background-image: url('../../../static/img/swiper_left.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  // margin-left: 10rem;
  outline: none;
}

.swiper-button-prev:hover {
  background-image: url('../../../static/img/swiper_left2.png');
}

.swiper-button-next {
  background-image: url('../../../static/img/swiper_right.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  // margin-right: 10rem;
  outline: none;
}

.swiper-button-next:hover {
  background-image: url('../../../static/img/swiper_right2.png');
}

.mySwiper {
  width: 100%;
  margin-top: 8rem;
  //margin-bottom: 15rem;
  // margin: 3rem 8rem;
}

.middle_banner {
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.swiper-pagination {
  position: relative;
  margin: 5rem 0 0;
}

.swiper-pagination-bullets {
  bottom: 0;
}
/deep/ .swiper-pagination-bullet-active{
  background: #5B6370 !important;
}

//.swiper-slide-prev {
//  transform: translate3d(30px, 0px, -120px) rotateX(0deg) rotateY(60deg) scaleX(0.7) !important;
//}
//
//.swiper-slide-next {
//  transform: translate3d(0px, 0px, -120px) rotateX(0deg) rotateY(-60deg) scaleX(0.7) !important;
//}
//
//.swiper-slide-active, .swiper-slide-duplicate-active {
//  transform: scale(1) !important;
//}

@media screen and (max-width: 1200px) {
  .mySwiper {
    margin-bottom: 5rem;
  }

  .page_btn_div {
    display: none;
  }

  .swiper-pagination {
    display: block;
  }


  .swiper_title {
    margin: 5rem 0 10rem;
  }

  .book1_img {
    height: 30rem;
  }

  .middle_banner {
    margin-top: 8rem !important;
    width: 100%;
  }

  .swiper-button-prev {
    display: none;
    // width:auto;
    // left:1px;
  }

  .swiper-button-next {
    display: none;
    // width:auto;
    // right:1px;
  }

  .bannerleft {
    display: none;
  }

  .bannerright {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .mySwiper{
    margin-top: 0;
  }
  .book1_img {
    height: 20rem;
  }
  .swiper_title{
    margin: 1rem;
    font-size: 2rem;
  }
}
</style>
